module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_m_normal.4409174b.png";